import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../actions/undo.actions';
import { StateDiff } from '../actions/undo.actions';

declare module 'react-redux' {
  interface DefaultRootState {
    undo: UndoState;
  }
}

export interface UndoState {
  undoStack: Array<StateDiff>;
  restoreStack: Array<StateDiff>;
}

const initialStateFactory = (): UndoState => ({
  undoStack: [],
  restoreStack: [],
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(undoActions.saveUndoState, (state, { toPrevious, toNext }) => {
    const undoStack = state.undoStack.concat([{ toPrevious, toNext }]);
    return {
      ...state,
      undoStack,
      restoreStack: [],
    };
  }),
  on(undoActions.undo, (state) => {
    const undoStack = state.undoStack.slice();
    const log = undoStack.pop();

    if (log == null) {
      return state;
    }

    const restoreStack = state.restoreStack.concat([log]);
    return {
      ...state,
      undoStack,
      restoreStack,
    };
  }),
  on(undoActions.restore, (state) => {
    const restoreStack = state.restoreStack.slice();
    const log = restoreStack.pop();

    if (log == null) {
      return state;
    }

    const undoStack = state.undoStack.concat([log]);
    return {
      ...state,
      restoreStack,
      undoStack,
    };
  }),
);
